import { Link } from 'react-router-dom'
import { myWorkQueueApi } from '../../api/workQueue'
import type { WidgetProps } from './types'
import { useWidgetData } from './useWidgetData'
import { Stat, WidgetBody, formatNum } from './WidgetBody'

/** La mia coda: quante voci e quante ferme. Legge l'api esistente `/api/work-queue`. */
export function WorkQueueSummaryWidget(props: WidgetProps) {
  void props
  const state = useWidgetData(() => myWorkQueueApi.list(undefined, 200), 'wq')
  return (
    <WidgetBody state={state}>
      {q => (
        <>
          <div className="md-mini-stats">
            <Stat label="In coda" value={formatNum(q.total)} />
            <Stat label="Ferme" value={formatNum(q.items.filter(i => i.isStale).length)} hint="Voci ferme tra le prime caricate" />
          </div>
          <Link to="/work-queue" className="md-typescale-body-small d-inline-block mt-2">
            Apri la coda
          </Link>
        </>
      )}
    </WidgetBody>
  )
}
